import React from 'react'
import styles from './Footer.module.scss'
import logo from '../../image/Header/logo.svg'
import email from '../../image/Map/email-icon.svg'
import company from '../../image/Map/company.svg'
import phone from '../../image/Map/phone.svg'

const Footer = ({isOpen}) => {

    return (
        <footer className={styles.main}>
            <div className={styles.container}>
                <div className={styles.box}>
                    <img className={styles.logo} src={logo} alt = 'логотип'/>
                    <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={email} alt = 'icon'/>
                                <a className={styles.link_email}  href="mailto:musorkin71@mail.ru" target='_blank' rel='noopener noreferrer'>musorkin71@mail.ru</a>
                        </div>
                        <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={phone} alt = 'icon'/>
                                <div className={styles.box_time}>
                                    <a className={styles.link_phone} href="tel:+79777238808" target='_blank' rel='noopener noreferrer'>+7 (977) 723-88-08</a>
                                </div>
                        </div>
                        <div className={styles.box_contacts}>
                                <img className={styles.icon_contacts} src={company} alt = 'icon'/>
                                <div className={styles.box_time}>
                                    <p className={styles.link_phone}>ИП Лезин Николай Николаевич ИНН&nbsp;711707058933</p>
                                </div>
                        </div>
                        
                </div>
                <div className={styles.box}>
                    <p className={styles.text}>&#169; {new Date().getFullYear()} Все права защищены.</p>
                    <a className={styles.link_developer} target='_blank' rel='noopener noreferrer' href='https://tihonov-studio.ru/' aria-label='сайт тихонова дмитрия'>
                        <p className={styles.text}>Разработано:<span> TD</span></p>
                    </a>
                </div>
            </div>
        </footer>
    )
}

export default Footer